import React, { useState } from "react";
import { Link } from "react-router-dom";
import { submitSignupRequest } from "../../services/signupRequestService";

const Register: React.FC = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [roleRequested, setRoleRequested] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const tenant = localStorage.getItem("currentTenant");
  const user = localStorage.getItem("user");
  const tenantId = tenant ? JSON.parse(tenant).id : user ? JSON.parse(user).tenant_id : "";

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    try {
      await submitSignupRequest({
        tenant_id: tenantId || undefined,
        full_name: fullName,
        email,
        phone: phone || undefined,
        role_requested: roleRequested || undefined,
        business_name: businessName || undefined,
        message: message || undefined,
      });
      setSubmitted(true);
    } catch (err) {
      setError("Unable to submit your request right now. Please try again.");
    }
  };

  return (
    <div className="agri-theme-root agri-grain-overlay max-w-2xl mx-auto py-16 px-6 rounded-2xl">
      <div className="text-center mb-8">
        <h2 className="font-display text-2xl font-bold text-agri-forest-900 mb-2">
          Registration Restricted
        </h2>
        <p className="text-gray-500 dark:text-gray-400">
          Only admins can create new user accounts. Submit a request and the
          admin will invite you.
        </p>
      </div>

      {submitted ? (
        <div className="bg-green-50 border border-green-200 text-green-700 rounded-lg p-6 text-center">
          Your request has been sent. We will contact you soon.
          <div className="mt-4">
            <Link to="/auth/login" className="inline-block btn-primary">
              Back to Login
            </Link>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="agri-organic-card p-6 space-y-4">
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-3">
              {error}
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Full Name
            </label>
            <input
              required
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full rounded-md border px-3 py-2 text-sm"
              placeholder="Your name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Email
            </label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border px-3 py-2 text-sm"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Phone (optional)
            </label>
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full rounded-md border px-3 py-2 text-sm"
              placeholder="+234..."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Role Requested (optional)
            </label>
            <input
              value={roleRequested}
              onChange={(e) => setRoleRequested(e.target.value)}
              className="w-full rounded-md border px-3 py-2 text-sm"
              placeholder="Trader, Retailer, Distributor"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Business Name (optional)
            </label>
            <input
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              className="w-full rounded-md border px-3 py-2 text-sm"
              placeholder="Okoro Foods"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Message (optional)
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full rounded-md border px-3 py-2 text-sm"
              rows={4}
              placeholder="Tell us what you want to sell and your location..."
            />
          </div>
          <div className="flex items-center justify-between">
            <button type="submit" className="btn-primary">
              Contact Admin
            </button>
            <Link to="/auth/login" className="text-sm text-gray-500 hover:underline">
              Back to Login
            </Link>
          </div>
        </form>
      )}
    </div>
  );
};

export default Register;
